<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui';

defineProps<{
	/** Used for aria-label, not rendered. */
	label: string;
	items: DropdownMenuItem[][];
}>();
</script>

<template>
	<DDropdownMenu :items>
		<button
			type="button"
			class="group/trigger absolute inset-0 flex cursor-pointer items-center justify-end pe-0"
			:aria-label="$t('blocks.form_field.label_menu_trigger', { label })"
			tabindex="-1"
		>
			<DIcon
				name="lucide:chevron-down"
				class="size-3 text-muted opacity-0 group-hover:opacity-100 group-data-[state=open]/trigger:opacity-100"
			/>
		</button>
	</DDropdownMenu>
</template>
